import script from "./PhoneLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneLogin.vue?vue&type=script&setup=true&lang=js"

import "./PhoneLogin.vue?vue&type=style&index=0&id=cfec6290&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfec6290"]])

export default __exports__